<template>
  <div class="attachments-uploader-comp">
    <p>上传附件（非必填）</p>
    <div class="img-header">
      <div class="exemption-img" v-for="(item, i) in imageUrls" :key="i">
        <div class="close-img" @click="delImg(i)"><span>x</span></div>
        <img :src="item" alt="" />
      </div>
      <image-uploader
        id="fileInput"
        class="exemption-image-uploader"
        :maxWidth="512"
        :autoRotate="true"
        outputFormat="file"
        :preview="false"
        accept="image/*"
        :doNotResize="['gif', 'svg']"
        @input="handleImage"
      >
        <label for="fileInput" slot="upload-label">
          <img :src="imgUploadLabel" />
        </label>
      </image-uploader>
    </div>
  </div>
</template>
<script lang="ts">
import { BaseComponent, Component, Emit, Prop } from 'kuaidong-component'
import { UploadPresignInfo } from 'kuaidong-model'
import ImageUploader from 'vue-image-upload-resize'
import axios from 'axios'
import { AUpload } from 'kuaidong-api'

@Component({
  components: {
    ImageUploader,
  },
})
export default class AttachmentsUploader extends BaseComponent {
  @Prop({ type: String, required: true })
  imgUploadLabel!: string

  @Prop({ type: Array, required: true })
  imageUrls!: string[]

  async handleImage(file: File) {
    try {
      const presign: UploadPresignInfo = await AUpload.presign('exemption-info', file.name)

      await axios.put(presign.file_upload_url, file, {
        headers: {
          'Content-Type': presign['content-type'],
        },
      })
      await AUpload.markUploaded()
      if (presign.fetch_url) {
        this.uploadImg(presign.fetch_url)
        this.uploadSuccess()
      }
    } catch (e) {
      this.uploadFailed()
    }
  }

  @Emit('uploadImg')
  uploadImg(imageUrl: string) {
    return imageUrl
  }

  @Emit('delImg')
  delImg(index: number) {
    return index
  }

  @Emit('uploadSuccess')
  uploadSuccess() {
    return
  }

  @Emit('uploadFailed')
  uploadFailed() {
    return
  }
}
</script>
<style lang="less">
.attachments-uploader-comp {
  margin-top: 16px;
  font-size: 14px;
  p {
    text-align: left;
  }
  > .img-header {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    > .exemption-img {
      position: relative;
      margin-top: 10px;
      margin-right: 16px;
      > .close-img {
        position: absolute;
        top: -8px;
        right: -8px;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background-color: rgba(0, 0, 0, 0.6);
        color: #ffffff;
      }

      > img {
        width: 48px;
        height: 48px;
        border-style: solid;
        border-color: #e1e4ed;
        border-width: 1px;
        border-radius: 8px;
      }
    }

    > .exemption-image-uploader {
      > .fileinput {
        display: none;
      }
      display: flex;
      margin-top: 10px;

      > label {
        > img {
          margin-right: 16px;
          width: 48px;
          height: 48px;
        }
      }
    }
  }
}
</style>
